import * as React from 'react';
import { isPartialDate } from 'neuro-utils';
import { sortDocuments } from 'Utility/randomUtil';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { useAppSelector } from 'Store/index';
import { fm } from 'Components/FormatMessage';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType } from 'Utility/documentHandling';
import type { TDiagnosticSurveyDocumentType } from '../utils';

const DiagnosticSurveyDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const sortedAndMergedMyDocuments = useAppSelector(s => s.myapp.sortedAndMergedDocuments);
  const myDocs = filterDocumentsByType(sortedAndMergedMyDocuments, ['fbimod', 'iadl']);

  const docs = documents.filter(d => !['diagnosis', 'mmse'].includes(d._type));

  const comparator = sortDocuments([{ type: 'date', sortField: 'date' }]);
  const sortedDocs = docs.concat(myDocs).sort(comparator);

  return (
    <React.Fragment>
      <TileContentMaker
        type="recentList"
        data={sortedDocs.map(d => ({
          date: 'date' in d && isPartialDate(d.date) ? formatPartialDate(d.date) : '',
          title: fm(`diagnosticSurvey.${d._type}.title`),
          key: d._id,
        }))}
      />
    </React.Fragment>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<TDiagnosticSurveyDocumentType>[];
}

export default DiagnosticSurveyDash;
